export default {
  //SubMenu
  clientsList: "Client list",
  collaborators: "Collaborators",
  myDashboard: "My Dashboard",
  collaboratorSpace: "Collaborator Space",
  myBalanceSheet: "My Balance sheet",
  dashboardsModels: "Dashboard templates",
  slidesModels: "Slide Templates",
  presentation: "Presentation",
  //Headers
  slidesList: "Slides list",
  collaboratorList: "Collaborators list",
  templatesDashboard: "Dashboard templates",
  //Subheaders
  clientsListSubHeader: "visualize and manage your customer files",
  slidesListSubHeader: "visualize and manage your slides",
  collaboratorListSubHeader: "Find all the collaborators.",
  templatesDashboardSubHeader: "visualize and manage your dashboards",
  balanceSheetSubHeader: "DETAILED FINANCIAL HEALTH VIEW",

  //Actions
  add: "Add",
  use: "use",
  post: "post",
  send: "send",
  read: "read",
  edit: "edit",
  exit: "Exit",
  save: "Save",
  hide: "hide",
  play: "Play",
  Apply: "Apply",
  cancel: "Cancel",
  import: "Import",
  delete: "Delete",
  update: "Update",
  return: "Return",
  logout: "Logout",
  search: "Search",
  sortBy: "Sort by",
  goBack: "Go back",
  seeAll: "See all",
  prepare: "Prepare",
  validate: "Validate",
  associate: "associate",
  duplicate: "duplicate",
  explore: "Explorer",
  selectAll: "select all",
  deselectAll: "Deselect All",
  signIn: "Login / Sign up",
  generate: "Generate",
  regenerate: "Regenerate",
  showMore: "Read more",
  addToCalendar: "Add to Calendar",
  //Label
  to: "to",
  the: "the",
  year: "Year",
  next: "Next",
  previous: "Previous",
  client: "Client",
  filter: "Filter",
  ratiosOf: "Ratios of",
  admin: "Administrator",
  error: "Error",
  rendezVous: "Appointment",
  caution: "Caution",
  balanceSheetOf: "Balance sheet of",
  typeOfEnterprise: "Type of enterprise",
  juridicalForm: "Juridical Form",
  diaporama: "slideshow",
  unknown: "unknown",
  closingDate: "Closing Date",
  duration: "Duration",
  startDate: "Start date",
  endDate: "End date",
  dateRange: "date range",
  createdAt: "Created At",
  updatedAt: "Updated At",
  increaseOf: "increase of",
  decreaseOf: "decrease of",
  inferior: "inferior",
  superior: "superior",
  average: "in the average",
  settings: "Settings",
  communities: "Communities",
  TAMTAMApplications: "TAMTAM Applications",
  Event: "Event",
  Survey: "Survey",
  profile: "Profile",
  preview: "Preview",
  title: "Title",
  content: "Content",
  visibility: "visibility",
  me: "Me",
  indicator: "Indicator",
  indicators: "indicators",
  nbrOfYears: "Number of years",
  maxValue: "max value",
  minValue: "min value",
  annexeCategory: "Annex category",
  annexeYear: "Annex year",
  fileName: "File name",
  category: "Category",
  importedAt: "Imported at",
  action: "Action",
  role: "Role",
  roles: "Roles",
  recipients: "recipients",
  recipient: "recipient",
  files: "Files",
  categories: "categories",
  allCategories: "All categories",
  all: "All",
  today: "Today",
  yesterday: "Yesterday",
  otherday: "Otherday",
  week: "Week",
  comments: "comments",
  hidden: "Hidden",
  visible: "Visible",
  certified: "Certified",
  main: "Main",
  configuration: "Configuration",
  authorizations: "autorisations",
  newUser: "New user",
  users: "Users",
  user: "User",
  editor: "Editor",
  total: "Total",
  as: "as",
  and: "and",
  sentTo: "sent to",
  justSent: "Just sent",
  resendAgain: "Resend again",
  preferences: "Preferences",
  recentActivities: "recent activities",
  clientFolders: "client folders",
  configuredFolders: "Configured Folders",
  noAnnexesFolders: "Files Without Annexes",
  noConfiguredFolders: "Unconfigured Folders",
  noActivities: "no activities",
  noOptions: "geen opties",
  relizedDuration: "relized duration",
  traitMyFolders: "Trait my folders",
  clientIndicator: "Client indicator",
  exercise: "Exercise",
  home: "Home",
  none: "none",
  mutation: "mutation",
  financial: "financial",
  treasury: "Treasury",
  annexes: "annexes",
  status: "Status",
  view: "View",
  lastImport: "Last import",
  folder: "Folder",
  extraSlideDescription:
    "Slides containing notes that you can enter, customize, and add to the presentation.",
  remerciementDescription:
    'Slide containing a thanking note, "Thank you for your attention", an avatar of the manager with his first name, last name, email address and mobile number.',
  questionsDescription:
    "Slide containing a request if the customer has questions, “Do you have any questions?”.",
  finalDateValidationLink: "Valid until",
  periodValidationLink: "Period of validity of the link :",
  monday: "Monday",
  tuesday: "Tuesday",
  wednesday: "Wednesday",
  thursday: "Thursday",
  friday: "Friday",
  saturday: "Saturday",
  sunday: "Sunday",
  myFolders: "My folders",
  myPresentations: "My presentations",
  by: "By",
  private: "Private",
  public: "Public",
  duplicated: "Duplicated",
  original: "Original",
  share: "Share",
  standard: "Standard",
  created: "Created",
  toUse: "To use",
  frozen: "Frozen",
  slide: "Slides",
  sharedWithCommunity: "Shared With Community",
  yes: "Yes",
  no: "No",
  new: "New",
  editableTemplate: "Editable template",
  //Titles
  recordVocal: "Record vocal comment",
  library: "Library",
  myTemplates: "My templates",
  slideView: "Slide view",
  createSlideTemplate: "create slide template",
  createDashboardTemplate: "create dashboard template",
  noLegalForms: "No legal forms",
  presentations: "Presentations",
  clientType: "Type Client (CRM)",
  clientGroup: "Groupe Client (CRM)",
  inSomeFigures: "In Some Figures",
  affectedModel: "Affected model",
  clientForm: "Client Form",
  manageAssociations: "Manage associations",
  managerSpace: "Manager Space",
  manageExplanation: "Manage explanations",
  manageCategories: "Manage categories",
  addExplanation: "Add explanation",
  addExplanations: "Add explanations",
  addRecipients: "Add recipients",
  addEmailTemplates: "Add Email-templates",
  typeExplanations: "Type your explanation (3 languages available)",
  associationLegalForm: "Association Dashboard / Legal Form",
  dashboardcreated: "Created Dashboards models",
  dashboardstandard: "Standard Dashboards models",
  associateClientTitle: "Associate clients to principale dashboard",
  companyNaturalPerson: "Company natural person",
  companyLegalPerson: "Company legal person",
  profitability: "Profitability",
  solvency: "Solvency",
  liquidity: "Liquidity",
  balanceSheet: "Balance Sheet",
  configureOrganization: "Configure organization",
  exercisesConfiguration: "Exercises configuration",
  dashboard: "Dashboard",
  dashboardPrincipal: "principal dashboard",
  slideConfigurationPage: "Slide configuration",
  slideTitle: "Slide title",
  slideBackgroundColor: "Background color",
  slideComponentColor: "Component color",
  slideLayoutTitle: "Change Layout",
  componentsList: "Components list",
  componentConfig: "Component configuration",
  createdSlides: "Created Slides",
  standardSlides: "Standard Slides",
  allSlides: "All slides",
  titleDuplicateSlide: "Duplicate Slide",
  titleAddSlide: "Add Slide",
  titleUseSharedSlide: "Use this slide",
  titleAddDashboard: "Add dashboard",
  titleUseSharedDashboard: "Use dashboard",
  addPresenter: "Add a presenter",
  importCustomerBalance: "Import customer balance",
  dashboardComposition: "Dashboard Composition",
  slideComposition: "Slide Composition",
  configuredExercises: "Configured Exercises",
  importedBalances: "Imported Balances",
  updateCategory: "Update category",
  createCategory: "Create category",
  addComment: "add a comment ...",
  moveSlideTemplate: "Move the slide template",
  addSlideTemplate: "Insert a slide template after the current slide",
  switchSlideTemplate: "Replace the current slide by a slide template",
  chooseERP: "Choose the ERP",
  chooseModel: "Choose the model",
  undefinedVAT: "VAT number is undefined",
  titleDuplicateDashboard: "Duplicate Dashboard",
  attacherAnnexeCategorie: "attached category annex",
  descriptionExercisesModel: "Description of the exercises model",
  yearOfExercise: "Year of exercise",
  MultipleYearsModel: "Multiple model ",
  FiveYearsModel: "5 years model",
  TwoYearsModel: "2 years model",
  OneYearModel: "1 year model",
  comparedModel: "Comparative exercise model",
  winbooksModel: "1 year model",
  importAnnexes: "Annexes import",
  importBalance: "Balance import",
  importCustomerAnnexe: "Import of customer annexes",
  seeMore: "See more",
  otherUser: "Other user(s)",
  chooseCategory: "Choose category",
  chooseYear: "Choose year",
  selectCommunity: "choose your community",
  categoriesList: "Categories list",
  explanationsList: "Explanations list",
  HiddenAnnex: "Hidden annex",
  VisibleAnnex: "Visible annex",
  extraSlides: "Extra slides",
  annexState: "Annex State",
  newSlide: "New slide",
  newDashboard: "New dashboard",
  useAModele: "Use a model",
  slidePosition: "Slide position",
  ajouterExtraSlideTitle: "add extra slide",
  editExtraSlideTitle: "Edit extra slide",
  titleModalCategory: "Create or edit category",
  chooseExtraSLide: "Choose an Extra Slide",
  dashboardYear: "Dashboard of the year",
  categoryList: "List of category",
  addExtaSLide: "Add an Extra SLide",
  addExercise: "Add exercise",
  removeExercise: "Remove exercise",
  associateClient: "associate to dashboard",
  updateExplanation: "Update explanation",
  undefinedPresentationDate: "undefined presentation date",
  presentationNotPrepared: "Presentation not prepared",
  presentationDone: "Presentation done",
  preparedPresentation: "Prepared presentation",
  readyPresentation: "Presentation Ready",
  notPrepared: "not prepared",
  prepared: "prepared",
  presented: "presented",
  presentedThe: "Presented the",
  toPresenteThe: "to presente the",
  frExplanation: "French explanation",
  enExplanation: "English explanation",
  nlExplanation: "Dutch explanation",
  processing: "Processing",
  frTitle: "French Title",
  enTitle: "English Title",
  nlTitle: "Dutch Title",
  externalLinks: "External links",
  notConfigured: "Not configured",
  undefinedDate: "Undefined Date",
  noAnnexes: "No annexes",
  withAnnexe: "With annexe",
  notCompleted: "Not completed",
  completed: "Completed",
  accountingRoles: "Accounting roles",
  organizationRoles: "Organization roles",
  dashboardPrivileges: "dashboard privileges",
  associatePrivileges: "associate privileges",
  allowCreateDashboard: "Allow create dashboard",
  allowCreateSlide: "Allow create slide",
  allowUpdateDashboard: "Allow update dashboards",
  allowUpdateSlide: "Allow update slides",
  allowAccessDashboard: "Allow access to dashboard list",
  allowAccessCollaborator: "Allow access to collaborators list",
  allowAccessParameters: "Allow access to parameters list",
  allowAccessSlide: "Allow access to slide list",
  allowAssociateDashboards: "Allow associate dashboards",
  parameterPrivileges: "Parameter privileges",
  companyDateCreation: "Date of creation of the company",
  presentationPreparation: "Preparation of the presentation",
  preparationPresention: "Preparation of the presentation",
  creationDashboard: "Dashboard creation",
  creationSlide: "Creation of slides",
  saveFinish: "Save & Finish",
  makeVisible: "Make visible",
  addCategory: "Add a category",
  clientVisibility: "Client visibility",
  organizationState: "organization state",
  datePresentation: "Date of presentation",
  linkGenered: "Link generated",
  linkNotGenered: "Link not generated",
  presentationLink: "Presentation link",
  feedbackRequest: "Feedback request",
  sendRequest: "",
  sendLink: "",
  sendAppointment: "",
  addNew: "Add new",
  sendToAddress: "send to address",
  refresh: "Apply default filter",
  presentationExtraSlide: "Extra slides of the presentation",
  slideRemerciement: "Thanking Slide",
  slideQuestions: "Questions Slide",
  linkPresentation: "Presentation's shareable link",
  titleSharedDashboard: "Share dashboard",
  titleSharedSlide: "Share slide",
  titleVisibilitySlide: "Slide Visibility",
  titleVisibilityDashboard: "Dashboard Visibility",
  notifyNewDashboard: "A new dashboard ",
  notifyAtYourDisposal: " is at your disposal",
  notifyNewDashboards: " New dashboards are at your disposal ",
  notifyNewSlide: "A new slide ",
  notifyUsingUa:
    "Warning: This link will no longer be functional. Please login via this link: ",
  notifyNewSlides: " New slides are at your disposal",
  notifyNewSharedDashboard: "A new shared dashboard",
  notifyNewSharedDashboards: "  New shared dashboards are at your disposal",
  notifyNewSharedSlide: "A new shared slide ",
  notifyNewSharedSlides: " New shared slides are at your disposal",
  notifyNewImportedBalance: "A new scale is imported for the customer ",
  notifyNewImportedBalances: " New imported scales are at your disposal",
  slideEditableInfos:
    "This slide will be shared with the other organizations with the right to use it as is",
  dashboardEditableInfos:
    "This dashboard will be shared with the other organizations with the right to use it as it is",

  //Messages
  successfulAction: "Successful action",
  operationCompleted: "action performed successfully",
  errorOccured: "An error occured, Please retry later.",
  searchByNameOrVATnumber: "Search by name or VAT number",
  searchBySlideName: "Search by slide name ...",
  searchByDashboardName: "Search by dashboard name ...",
  searchByName: "Recherche par nom",
  wip: "In development",
  notifUpdates: "Notifications of updates",
  nothingToShow: "Nothing to show",
  incorrectFile: "Imported file is incompatible !",
  noPresentations: "No presentation found",
  pageNotFound: "This Page Could Not Be Found!",
  nothingFound: "Oops, No results found for your search",
  justSentToRecipients: "Some selected recipients have just received an email",
  moreExercicesRequired:
    "- This <b>balance model</b> needs more exercises configured...",
  applyAuthorizationMessage: "Apply authorization to selected users",
  oops: "Oops",
  notAvailable: "Not available",
  noResult: "No results found",
  typeCategoryTitle: "Type the title of your category (3 languages available)",
  updateExercices: "exercises configuration is updated",
  readyDashAssociate: "Dashboard ready to be associated with clients.",
  accessDenied: "Access denied",
  dashboardNotFound: "Dashboard not found",
  organizationNotFound: "organization not found",
  recipientsNotFound: "no recipients found! please add some",
  emailModelsNotFound: "No mail models found! please add some",
  goClientPage: "You can go back to the Clients List Page",
  noBalanceImported: "No imported balance",
  noBalanceImportedMessage:
    "No balance have been imported to date. If you have any questions about your file, please contact your manager",
  sendSuccess: "Successful sending",
  mailSent: "Mail sent successfully",
  importBalanceSuccess: "Balance import is carried out successfully",
  importAnnexeSuccess: "Annexe import is carried out successfully",
  updateAssociationSuccess: "the association is carried out with success",
  definePresentationDate: "Set a presentation date",
  selectPresentationDate: "Select apresentation date...",
  presentationPreparedQuestion: "Presentation prepared ?",
  presentationPresentedQuestion: "Presented to the client ?",
  presentationFreezedQuestion: "Freeze your presentation ?",
  setPresentationState: "Mark the state of the presentation",
  slideSaved: "Slide saved successfully",
  deleteComponentConfirm: "Do you want to delete this component ?",
  cancelConfirmContent: "Any changes will be Canceled.",
  cancelConfirm: "Do you Want to cancel?",
  exitConfirm: "Do you want to Exit?",
  deleteConfirm: "Do you Want to delete?",
  sharedConfirm: "Do you want to share?",
  deleteConfirmContent: "dashboard will be deleted",
  deleteSlideConfirmContent: "Slide will be deleted",
  sharedSlideConfirmContent: "Slide will be shared",
  duplicatedSlideConfirmContent: "Slide will be duplicated",
  saveSuccess: "Saved successfully",
  importSuccess: "Import successful",
  removeSuccess: "Deletion is successful",
  dashboardDeleted: "Dashboard deleted",
  deleteDashboardSuccess: "Dashboard deleted successfully",
  dashboardDuplicated: "dashboard duplicate",
  duplicateDashboardSuccess: "Dashboard duplicate successfully",
  slideDuplicated: "slide duplicate",
  slideAdded: "slide added",
  addDashboardSuccess: "Dashboard added successfully",
  dashboardAdded: "Dashboard added",
  duplicateSlideSuccess: "slide duplicate successfully",
  addSlideSuccess: "slide added successfully",
  slideDeleted: "Slide deleted",
  slideDeletedSuccess: "Slide deleted successfully",
  slideSharedSuccess: "Slide shared successfully",
  slideShared: "Slide shared",
  successUpdated: "Successfully updated",
  categoryUpdated: "Category updated",
  categoryAdded: "Category added",
  categoryDeleted: "Category deleted",
  explanationAdded: "explanation added",
  explanationDeleted: "explanation deleted",
  commentDeleted: "Comment deleted",
  commentUpdated: "comment updated successfully",
  commentNull: "comment empty",
  explanationUpdated: "explanation updated successfully",
  explanationSaved: "explanation saved successfully",
  annexeDeleted: "Annex deleted",
  deleteConfirmation: "Delete confirmation",
  deleteExplanationContent: "Are you sure you want to delete this explanation?",
  deleteCategoryContent: "Are you sure you want to delete this category?",
  deleteAnnexeContent: "Are you sure you want to delete this annex?",
  deleteCommentContent: "Are you sure you want to delete this comment?",
  categoriesStateUpdated: "Categories state updated",
  mainAnnexeUpdated: "Main annexe updated",
  hiddenAnnexeUpdated: "Annexe visibility updated",
  certifiedAnnexeUpdated: "Annexe certification updated",
  addAnnexes: "Add multiple annexes",
  importAnnexeSub: "Import annexes by indicating there categories and years",
  updateSuccess: "Updated with Success",
  deleteExtraSlide: "Extra Slide will deleted",
  extraSlideDeleted: "Extra Slide deleted successfully",
  accessRole: "your profile does not allow you to access this option",
  gotLost: "You've moved so fast and got lost...",
  specialAssociationMessage:
    "This model is associated directly with the company",
  createdAssociationMessage:
    "This model is associated with the legal form of the company",
  defaultAssociationMessage: "This model is associated by default",
  noBalance: "No balance is imported for this organization.",
  importInProgress: "Balance's import in progress, hang on please ...",
  dragFile: "Drag and drop a file here, or click to select file to upload.",
  dragFiles: "Drag and drop files here, or click to select files to upload.",
  componentNotAvailable: "Component not available",
  duplicateSlideContent: "do you want to duplicate this slide ?",
  addSlideContent: "do you want to add this slide to my templates?",
  useSharedSlideContent:
    "do you want to use this slide ? (Please note that the chosen model cannot be modified)",
  addDashboardContent: "do you want to add this dashboard to my templates?",
  useSharedDashboardContent:
    "do you want to use this dashboard ? (Please note that the chosen model cannot be modified)",
  duplicateDashboardContent: "do you want to duplicate this Dashboard ?",
  categoryCreated: "Category created",
  visibilityUpdated: "Visibility updated",
  confirmationDeleteCategoryMessage:
    "Do you want to delete the category<br> it is possible to be linked to extra slides ?",
  confirmationDeleteCategoryTitle: "Confirmation of deletion",
  noConfiguredExercice:
    "Balance Sheet Exercises not yet configured for this organization.",
  incompleteOperation:
    "Unable to complete operation, incorrect data was submited",
  slideAlreadyUsedDeleteError:
    "Slide can't be deleted, it is used by another organization",
  slideAlreadyUsed:
    "Slide can't be updated, it is used by another organization",
  dashboardAlreadyUsedDeleteError:
    "Dashboard can't be deleted, it is used by another organization",
  dashboardAlreadyUsed:
    "Dashboard can't be updated, it is used by another organization",
  incompleteInfo:
    "Unable to save component,you must indicate all the information required",
  incompatibleModel:
    "The imported file does not correspond to the chosen model !",
  kluwerFiveYearsModelDescription:
    "This model includes 5 exercises imported by matching the exercises below and the exercises from the file to import",
  kluwerTwoYearsModelDescription:
    "This model includes 2 exercises imported by matching the exercises below and the exercises from the file to import",
  kluwerOneYearModelDescription:
    "This model imports only 1 exercise mentioned below",
  kluwercomparedModelDescription:
    "This model allows you to import 1 to 5 exercises. Its particularity is based on the fact that it is the only model that allows you to import an annual financial year composed of more than 4 periods (12 months)",
  winbooksModelDescription:
    "This model imports only 1 exercise mentioned below",
  multipleModelDescription: "This model imports one or more exercises ",
  applicationNotActivated:
    "Accounting application is not Activated for the current organization.",
  applicationNotActivatedIndication:
    "Please contact us for further information.",
  about_us_content:
    "is a suite of tools that enable a community to communicate, share, organise or collaborate efficiently. The platform is equipped with various applications assembled as required by the customer. Thanks to our mutuality tools, our customers have the latest technologies without having to develop them and invest in their core business.",
  annexeNotAvailable: "This annex is not available for this organization.",
  actionsOnExplinations: "Add, update or delete your explanations",
  actionsOnCategories: "Add, activate or deactivate your categories",
  listCommunity: "List of member communities",
  communityUnauthorised:
    "This community does not have access to this application",
  noRightsForOperations:
    "You don't have the rights for the requested operation",
  choiceModelEmail: "Choose an email template to send to the customer",
  alertHistoryMessage:
    "One or more emails have already been sent for this presentation, scroll for more details:",
  msgEmptyField: "Please enter the title of the slide (at least one language).",
  dashboardSharedSuccess: "Dashboard successfully shared",
  dashboardShared: "Dashboard Shared",
  sharedSlideContent: "Do you want to share this slide ?",
  sharedDashboardContent: "Do you want to share this dashboard ?",
  visibilitySlideContent: "Do you want to make this slide private ?",
  visibilityDashboardContent: "Do you want to make this dashboard private ?",
  slidePrivateSuccess: "Private Slide",
  dashboardPrivateSuccess: "Private Dashboard",

  // ENUM
  ACTIVATED: "ACTIVATED",
  DEACTIVATED: "DEACTIVATED",

  ADMIN: "Administrator",
  USER: "User",
  NONE: "None",
  EDITOR: "Editor",
  LEGAL_REPRESENTATIVE: "Legal Representative",
  OFFICIAL: "Official",
  EXTERNAL: "External",
  MANAGER: "Manager",
  COLLABORATOR: "Collaborator",
  SUPERVISOR: "Supervisor",

  READY: "READY",
  CONFIGURED: "CONFIGURED",
  PENDING: "PENDING",
  NOT_CONFIGURED: "NOT CONFIGURED",
  NO_ANNEXES: "WITHOUT ANNEXE",

  gd: "Client manager",
  ge: "Encoding manager",
  es: "Encoding Supervisor",
  super: "Supervisor",
  scan: "Scan Operator",

  white: "White",
  bleu: "Bleu",

  Activated: "Activated",
  Disabled: "Disabled",

  French: "French",
  English: "English",
  Dutch: "Dutch",

  Ready: "Ready",
  configured: "Configured",
  Pending: "Pending"
};



// WEBPACK FOOTER //
// ./src/i18n/en.js